import React from 'react';

import { Entry } from 'contentful';
import { NextPageWithLayout } from 'next';

import { InvestorSection } from '../../components/Cards/InvestorCard/components/InvestorSection';
import { Container } from '../../components/Container/Container';
import { Heading } from '../../components/Heading/Heading';
import { MetaTags } from '../../components/MetaTags/MetaTags';
import { TypeInvestorsSkeleton } from '../../interfaces/contentful';

export interface IInvestorProps {
  investorDetails: Entry<TypeInvestorsSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[];
}

export const Investors: NextPageWithLayout<IInvestorProps> = ({ investorDetails }) => {
  return (
    <div className="bg-lake-fog pt-10">
      <Container className="pb-40">
        <MetaTags
          title="Investors"
          description="Documents related to the investors"
          link="/investors"
        />
        <Heading as="h1">Investors</Heading>

        {investorDetails.map(investor => {
          const { title, description, displayDate, documents } = investor.fields;
          const { id } = investor.sys;
          return (
            <InvestorSection
              key={id}
              title={title}
              displayDate={displayDate}
              documents={documents}
              description={description}
            />
          );
        })}
      </Container>
    </div>
  );
};
